import api from "api";
import { supportApiBase } from "api/constants";
import { useQuery } from "react-query";
import { queryKeys } from "utils/misc";
import { Group } from "./templateDtos";

type TemplateGroupsResponseDto = { groups: { id: number; key: Group }[] };

export const useGetTemplateGroups = () =>
  useQuery(
    queryKeys.templateGroups,
    async () => {
      // @ts-ignore — v2 endpoint, not in OpenAPI types
      const response: TemplateGroupsResponseDto = await api.parse(`GET /treatments/schedules/groups`, {
        root: supportApiBase,
      });
      return response.groups.map(group => group.key);
    },
    { staleTime: Infinity }
  );
